import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormControl, NgForm } from '@angular/forms';
import { MessagesControlService } from 'src/app/_services/messages-control.service';
import 'quill-emoji/dist/quill-emoji.js'
import { MessageBody } from '../interfaces/MessageBody';
import { MatDialog } from '@angular/material/dialog';
import { CreateMessageFacade } from '../_services/createMessage.facade';
import { TreeData } from 'src/app/shared/sidebar-filter/TreeData';
import { MatSelect } from '@angular/material/select';
import { SelectUsersManuallyComponent } from '../components/select-users-manually-popup/select-users-manually.component';
import json2formdata from 'json2formdata';
import { ActivatedRoute, Router } from '@angular/router';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Location } from '@angular/common';
import { MessagesService } from '../_services/messages.service';
import { GlobalService } from 'src/app/_services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/dashboard/_services/data.service';

declare var $: any;

@Component({
  selector: 'app-create-message',
  templateUrl: './create-message.component.html',
  styleUrls: ['./create-message.component.scss']
})
export class CreateMessageComponent implements OnInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();
  messageForm: UntypedFormGroup = new UntypedFormGroup({
    title: new UntypedFormControl('', Validators.required),
    roles: new UntypedFormControl('', Validators.required),
    usersIds: new UntypedFormControl(''),
    type: new UntypedFormControl('', Validators.required),
    content: new UntypedFormControl('', Validators.required),
  });
  messageFormData = new FormData();

  @ViewChild('myForm') myForm: NgForm;
  @ViewChild('recepientSelect') recepientSelect: MatSelect;

  priorities = [];
  types: { value: string, status: string, name: string }[];
  recipients: { value: string, name: string }[];
  recipientsSelectedManually = [];
  showNames: boolean;
  editorStyle = {
    height: '250px',
    border: '0.8px #c0c0c0 solid',
    borderRadius: '7px 7px 0  0'
  }
  modules = {}
  content = ''
  isLoading: boolean = false;
  tableControls: any = { data: [] };
  rolesArray: TreeData[];
  usersModalComponent: SelectUsersManuallyComponent;
  selectedFile: File[] = [];
  preSelectedUsersIdsToGetMessage = [];
  searchTerm = "";
  allUsers = [];
  allUsersSelected = false;
  currLang;
  formType;
  singleReciepintName;
  constructor(private createMessageFacade: CreateMessageFacade,
    private globalService: GlobalService,
    private translate: TranslateService,
    private dataService: DataService,
    public dialog: MatDialog, private activatedRoute: ActivatedRoute, private messageControl: MessagesControlService,
    private router: Router, private _location: Location, private messagesService: MessagesService) {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
      
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    this.createMessageFacade.setSelectedUsersIds([], false);
  }

  ngOnInit(): void {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
      this.setFilterInfo()
      
    });
    this.messageControl.getMessagedRows().subscribe(res => {
      //preselected users from any list      
      this.preSelectedUsersIdsToGetMessage = res;
      if (this.preSelectedUsersIdsToGetMessage?.length == 1) {
        this.singleReciepintName = this.preSelectedUsersIdsToGetMessage[0].name;
      }
      this.createMessageFacade.setSelectedUsersIds(res.map(x => x.id), false)

      this.messageForm.get('roles').patchValue(['usersManually']);
    })
    let duplicateMsg = this.activatedRoute.paramMap.pipe(map(() => window.history.state))
    duplicateMsg.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.formType = data;
      if (data[0] && data[0].users.length > 0) {
        this.messageForm.get('title').patchValue(data[0].title);
        this.messageForm.get('content').patchValue(data[0].content);
        this.messageForm.get('type').patchValue(data[0].type);
        this.messageForm.get('roles').patchValue(['usersManually']);

        this.createMessageFacade.setSelectedUsersIds(data[0].users.map(x => x.id), false)
      }
    })
    this.filterUsers();
    this.setUsersInfo()
    this.modules = {
      'emoji-shortname': true,
      // 'emoji-textarea': true,
      'emoji-toolbar': true,
      'toolbar': [

        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'code-block'],

        [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
        [{ 'direction': 'rtl' }],                         // text direction

        [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        [{ 'font': [] }],
        [{ 'align': [] }],

        ['clean'],                                         // remove formatting button

        ['link', 'image', ''],                         // link and image, video
        ['emoji']
      ]
    }
    this.showNames = false;
    this.recipientsSelectedManually = [];
    this.priorities = ['message', 'notification'];
    this.translate.get('init').subscribe(res => {
      this.setSelectedData();
    });
    this.translate.onLangChange.subscribe(res => {
      this.setSelectedData();
    });
    this.messagesService.getSearchTermUsers().subscribe(searchTerm => {
      this.searchTerm = searchTerm;
      if (this.usersModalComponent) {
        let result = this.allUsers.filter(user => user.name.toLowerCase().includes(this.searchTerm.toLowerCase()));
        if (result.length === 0) {
          result = this.allUsers.filter(user => user.national_id.includes(this.searchTerm))
        }
        this.setTableInfo(result)
      }
    });
  }

  setSelectedData() {
    this.types = [
      { value: 'notification', name: this.translate.instant('messages.create-msg.notification'), status: 'enabled' },
      // { value: 'sms', name: 'SMS', status: 'disabled' },
      // { value: 'email', name: "Email", status: 'disabled' }
    ]
    this.recipients =
      [
        { value: 'user', name: this.translate.instant('messages.create-msg.all-user') },
        { value: 'parent', name: this.translate.instant('messages.create-msg.all-parent') },
        { value: 'helper', name: this.translate.instant('messages.create-msg.all-helper') },
        { value: 'supervisor', name: this.translate.instant('messages.create-msg.all-supervisor') },
        { value: 'teacher', name: this.translate.instant('messages.create-msg.all-teacher') },
        // { value: 'bus_driver', name: this.translate.instant('messages.create-msg.all-driver') },
        { value: 'security', name: this.translate.instant('messages.create-msg.all-guard') }
      ];
  }

  createMessageValidation(controlName) {
    return this.translate.instant(`messages.create-msg.${controlName}-required`)
  }

  submitMessage() {
    this.isLoading = true;
    let body: MessageBody;
    if (this.messageForm.get('roles').value[0] == 'usersManually') {
      // reduce method to remove dublicates from the array to be sent
      const userIds = this.createMessageFacade.getSelectedUsersIds$().getValue().reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
      if (userIds.length == 1) {
        this.allUsers.forEach(user => {
          if (userIds[0] == user.id) {
            this.singleReciepintName = user.name;
          }
        })
      }
      body = {
        title: this.messageForm.value.title,
        type: this.messageForm.value.type,
        users_ids: userIds,
        content: this.messageForm.value.content,
        attachments: this.selectedFile
      }
    } else {
      let user_roles = this.messageForm.value.roles.filter(role => role != 'usersManually')
      user_roles = user_roles.filter(role => role !== 'user')
      body = {
        title: this.messageForm.value.title,
        type: this.messageForm.value.type,
        user_roles: user_roles,
        content: this.messageForm.value.content,
        attachments: this.selectedFile
      }
    }
    const formData = json2formdata(body);
    this.createMessageFacade.sendMessage(formData).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      // snackbar
      var x = document.getElementById("snackbar-success");
      x.className = "show";
      setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);
      this.messageForm.reset();
      this.myForm.resetForm();
    }, err => {
      this.isLoading = false;
      var x = document.getElementById("snackbar-error");
      x.className = "show";
      setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);

    },()=>{
      this.messagesService.getMessages(25,1,'desc').subscribe(res=>{
        this.dataService.setAllMesssages$(res)
        this.isLoading = false;
        this.router.navigate(['messages/messages-list']);
      })
    })
  }
  onFileChanged(event) {
    let files: [] = event.target.files;
    [...files].forEach(x => {
      this.selectedFile.push(x);
    });
  }

  selectAllUsers() {
    this.allUsersSelected = !this.allUsersSelected
    if (this.allUsersSelected) {
      this.messageForm.get('roles').patchValue(['user', 'parent', 'helper', 'supervisor', 'teacher', 'bus_driver', 'security']);
    }
    else {
      this.messageForm.get('roles').patchValue([])
    }
  }

  onChangeRecepientsSelect(event) {
    if (this.messageForm.value.roles.includes('user')) {
      this.allUsersSelected = false;
      this.messageForm.get('roles').patchValue(this.messageForm.get('roles').value.filter(x => x != 'user'))
    }
    else {
      this.messageForm.get('roles').patchValue(this.messageForm.get('roles').value.filter(x => x != 'usersManually'))
    }
  }

  removeFile(index) {
    this.selectedFile.splice(index, 1);
  }

  discarMessage() {
    this.messageForm.reset();
    this.myForm.resetForm();
  }

  clearAllSelction() {
    this.createMessageFacade.setSelectedUsersIds([], false);
    this.preSelectedUsersIdsToGetMessage = [];
    this.singleReciepintName = null;
    this.messageControl.setMessagedRows([]);
    // this.messageForm.get('roles').patchValue(['usersManually']);
    this.messageForm.get('roles').setValue([])
   
  }

  openUsersPopup() {
    this.recepientSelect.close();
    this.setUsersInfo()
    const dialogRef = this.dialog.open(SelectUsersManuallyComponent, {
      disableClose: true,
      width: '90vw',
      data: {
        tableControls: this.tableControls,
        rolesArray: this.rolesArray,
        selectedUsers: this.createMessageFacade.getSelectedUsersIds$()
      }
    })
    this.usersModalComponent = dialogRef.componentInstance;
    this.filterUsers()
     this.messagesService.areMultipleRecepientsSelected.subscribe(()=>{
    if(this.messagesService._areMultipleRecepientsSelected.getValue()===true){ 
      this.messageForm.get('roles').patchValue(['usersManually']);
    }
    else if(this.messagesService._areMultipleRecepientsSelected.getValue()===false){
      this.messageForm.get('roles').setValue([])

    }
   })
   
  }

  setUsersInfo() {
    this.createMessageFacade.loadUsers();
    this.setFilterInfo()
    this.createMessageFacade.getAllUsers$().pipe(takeUntil(this.destroy$))
      .subscribe(users => { 
        if(users){
          users = users.filter(user=> user.roles !='bus_driver')
        }
        this.allUsers = users;
        this.setTableInfo(users)
      })
  }
  setFilterInfo() {
        this.isLoading = true;
    this.createMessageFacade.getCombined$().pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        this.rolesArray = [
          {
            name: this.translate.instant('messages.filter.roles'),
            type: "roles",
            value: "roles",
            disabled: false,

            parent: "",
            children: [
              // {
              //   name: this.translate.instant('messages.filter.drivers'),
              //   type: 'drivers',
              //   value: 'drivers',
              //   role: "bus_driver",
              //   parent: 'driversParent',
              //   disabled: false
              // },
              {
                name: this.translate.instant('messages.filter.parents'),
                type: 'parent',
                value: 'parents',
                role: "parent",
                parent: 'parentParent',
                disabled: false
              },
              {
                name: this.translate.instant('messages.filter.helpers'),
                type: 'helper',
                value: 'helper',
                role: "helper",
                parent: 'helperParent',
                disabled: false
              },
              {
                name: this.translate.instant('messages.filter.security'),
                type: 'security',
                value: 'drivers',
                role: "security",
                parent: 'securityParent',
                disabled: false
              },
              {
                name: this.translate.instant('messages.filter.supervisors'),
                type: 'supervisors',
                role: "supervisor",
                value: 'Supervisors',
                parent: 'supervisorsParent',
                disabled: false

              },
              {
                name: this.translate.instant('messages.filter.teachers'),
                type: 'teachers',
                role: 'teacher',
                value: 'drivers',
                parent: 'teacherParent',
                disabled: false

              }
            ]
          },
          {
            name: this.translate.instant('messages.filter.gates'),
            type: "gates",
            value: "gates",
            parent: "security",
            disabled: true,
            children: data.gates.map(x => {
              return {
                name: x.name, type: 'gates', value: x.name, parent: 'security', disabled: true,id:x.id
              }
            })

          },
          // {
          //   name: this.translate.instant('messages.filter.routes'),
          //   type: 'route_name',
          //   value: 'drivers',
          //   parent: 'drivers',
          //   disabled: true,
          //   children: data.routes.data.map(x => {
          //     return {
          //       name: x.route_name, value: x.route_name, parent: 'drivers', type: 'route_name', disabled: true,
          //     }
          //   })
          // },
          {
            name: this.translate.instant('messages.filter.grades'),
            type: "grade_name",
            value: "grades22,",
            parent: "gradesParent",
            disabled: true,
            children: data.grades.map(x => {
              return {
                name: x.name, type: 'grade_name', value: x.name, parent: 'grades', disabled: true,id:x.id, children:
                  x.school_classes.map(y => ({
                    name: y.name,
                    type: 'class_name',
                    value: y.name,
                    parent: "classes",
                    disabled: true,
                    id:y.id
                  }))
              }
            })
          }
        ]
        this.isLoading = false;
      })
  }
  setTableInfo(users) {
    this.tableControls = {
      selection: true,
      paging: false,
      title:'table-view.titles.users',
      selectedTitle:'table-view.selected-titles.users',
      totalTitle:'table-view.total-titles.users',
      view: 'list',
      columns: [

        {
          name: "",
          sort: false,
          type: "image",
          source: "image_path"
        },
        {
          name: this.translate.instant('messages.filter.username'),
          sort: false,
          type: "string",
          source: "name"
        },
        {
          name: this.translate.instant('messages.filter.role'),
          sort: false,
          type: "string",
          source: "roles",
          translateRole: true
        }
      ],
      data: users
    }
    if (this.usersModalComponent) {
      this.tableControls.data = users
      this.usersModalComponent.data.tableControls = this.tableControls
    }
  }

  filterUsers() {
    this.usersModalComponent?.getCheckedList$().pipe(takeUntil(this.destroy$)).subscribe((checkedList: any) => {
      this.createMessageFacade.setFiltersOptions(this.usersModalComponent.data.rolesArray);
      this.createMessageFacade.filterUsers(checkedList);
    })
  }

  te() {
    alert('as')
  }

  back() {
    this._location.back();
  }
}

